import React from 'react';
import { Grid, Container, Segment } from "semantic-ui-react";
const Terms = () => {
  return (
    <Segment className="py-0 hotspot" inverted vertical>
      {/* <div className="close--icon" /> */}
      <Container className="space-h">
        <div className="block__message height--100vh">
          <Grid verticalAlign='middle' centered>
            <Grid.Row>
              <div className="circle-tick"></div>
            </Grid.Row>
            <Grid.Row className="pb-0">
              <h1>ENJOY</h1>
            </Grid.Row>
            <Grid.Row>
              <p className="desc text-grey7">you get unlimited Wi-Fi</p>
            </Grid.Row>
          </Grid>
        </div>
      </Container>
    </Segment>
  )
}

export default Terms;


// WEBPACK FOOTER //
// ./src/components/hotspot/message/Message.js